var _circle, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagramIconFooter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.002,
    r: 16,
    fill: "#fff",
    fillOpacity: 0.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#instagram_icon_footer_svg__clip0_1091:2957)",
    fill: "#303996"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.998 7.935c2.627 0 2.939.01 3.976.058.96.043 1.48.204 1.828.338.427.158.814.41 1.131.737.327.317.579.704.736 1.131.135.347.295.868.34 1.827.046 1.038.056 1.35.056 3.977 0 2.628-.01 2.939-.057 3.977-.044.959-.204 1.48-.339 1.827a3.258 3.258 0 01-1.867 1.867c-.347.135-.868.295-1.828.34-1.037.047-1.348.056-3.976.056s-2.94-.01-3.977-.057c-.96-.044-1.48-.204-1.827-.339a3.048 3.048 0 01-1.131-.736 3.049 3.049 0 01-.737-1.131c-.134-.347-.295-.868-.338-1.827-.048-1.038-.058-1.35-.058-3.977 0-2.628.01-2.939.058-3.977.043-.96.204-1.48.338-1.827.158-.427.41-.814.737-1.131a3.049 3.049 0 011.131-.737c.347-.134.868-.295 1.827-.338 1.038-.048 1.35-.058 3.977-.058zm0-1.773c-2.673 0-3.008.011-4.057.06-1.048.047-1.763.213-2.389.457a4.824 4.824 0 00-1.743 1.135 4.824 4.824 0 00-1.135 1.743c-.243.626-.41 1.341-.457 2.388-.048 1.05-.06 1.385-.06 4.058 0 2.672.012 3.008.06 4.057.047 1.048.214 1.763.457 2.389a4.823 4.823 0 001.135 1.743c.492.5 1.086.888 1.743 1.135.626.243 1.341.41 2.389.457 1.05.048 1.384.06 4.057.06 2.673 0 3.008-.012 4.057-.06 1.048-.048 1.763-.214 2.389-.457a5.033 5.033 0 002.878-2.878c.243-.626.41-1.341.457-2.389.048-1.05.06-1.385.06-4.057 0-2.673-.012-3.008-.06-4.058-.047-1.047-.214-1.762-.457-2.388a4.824 4.824 0 00-1.135-1.743 4.824 4.824 0 00-1.743-1.135c-.626-.244-1.341-.41-2.389-.457-1.05-.049-1.384-.06-4.057-.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.998 10.95a5.053 5.053 0 100 10.105 5.053 5.053 0 000-10.106zm0 8.333a3.28 3.28 0 110-6.561 3.28 3.28 0 010 6.56zM21.251 11.93a1.18 1.18 0 100-2.363 1.18 1.18 0 000 2.362z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "instagram_icon_footer_svg__clip0_1091:2957"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(5.998 6.002)",
    d: "M0 0h20v20H0z"
  })))));
}

export default SvgInstagramIconFooter;